import { render, staticRenderFns } from "./modalSubirImagenRegistro.vue?vue&type=template&id=aea12be4&"
import script from "./modalSubirImagenRegistro.vue?vue&type=script&lang=js&"
export * from "./modalSubirImagenRegistro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports